import {useEffect, useRef} from 'react';

import uniqueId from 'lodash.uniqueid';
import moment from 'moment';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

export const useDateValidation = (
    startDate: string | null,
    endDate: string | null,
    onChangeEndDate: (val: string) => void,
): {hasInvalidRange: boolean} => {
    const {onCreateNote, onCloseNote} = usePushNotification();
    const noteIdRef = useRef<string | null>(null);
    const dismissedRef = useRef(false);
    const hasInvalidRange = Boolean(startDate && endDate && moment(startDate).isAfter(endDate));

    useEffect(() => {
        dismissedRef.current = false;
    }, [startDate, endDate]);

    useEffect(() => {
        if (!hasInvalidRange) {
            if (noteIdRef.current) {
                onCloseNote(noteIdRef.current);
                noteIdRef.current = null;
            }
            dismissedRef.current = false;
            return;
        }

        if (dismissedRef.current || noteIdRef.current) {
            return;
        }

        const noteId = uniqueId('date-validation-');
        noteIdRef.current = noteId;
        onCreateNote({
            id: noteId,
            status: Status.WARNING,
            buttonProps: {
                iconProps: {type: Icons.CLOSE},
                onClick: () => {
                    onChangeEndDate('');
                    dismissedRef.current = true;
                    noteIdRef.current = null;
                },
            },
            body: () => 'End Date must be equal to or after Start Date',
        });

        return () => {
            if (noteIdRef.current === noteId) {
                onCloseNote(noteId);
                noteIdRef.current = null;
            }
        };
    }, [hasInvalidRange, onCreateNote, onCloseNote, onChangeEndDate]);

    return {hasInvalidRange};
};
